<template>
    <div class="card blue">
      <h2 class="card-h2"><span>Seattle Council Information</span></h2>
      <div class="card-content">
        <ul class="link-list blue">
          <li><a href="http://www.seattle.gov/council/meet-the-council/find-your-district-and-councilmember"><i class="material-icons">search</i> Find your district and council member</a></td></li>
          <li><a href="https://www.seattle.gov/council/meet-the-council"><i class="material-icons">contact_phone</i> Council contact information</a></td></li>
          <li><a href="https://www.seattle.gov/council/calendar"><i class="material-icons">date_range</i> Calendar</a></td></li>
          <li><a href="https://www.seattle.gov/council/committees"><i class="material-icons">people</i> Committees</a></td></li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
  name: 'seattleCityCouncilInformation'
}
</script>

<style lang="scss">
@import "./src/sass/link-list";
</style>



// WEBPACK FOOTER //
// SeattleCityCouncilInformation.vue?1e3a310e